import { render, staticRenderFns } from "./our-team.vue?vue&type=template&id=73f90cea&scoped=true&"
import script from "./our-team.vue?vue&type=script&lang=js&"
export * from "./our-team.vue?vue&type=script&lang=js&"
import style0 from "./our-team.vue?vue&type=style&index=0&id=73f90cea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f90cea",
  null
  
)

export default component.exports